
/**
*   工具函数集中管理
**/
var __Xtool_Utils = (function () {
    /**
     * @param { String } msg 
     * @param { Number } duration 
     */
    var Toast = function (msg, duration) {
        duration = isNaN(duration) ? 1000 : duration;
        const m = document.createElement('div');
        m.innerHTML = msg;
        m.style.cssText = "font-family:siyuan;max-width:60%;min-width: 150px;padding:0 14px;height: 40px;color: rgb(255, 255, 255);line-height: 40px;text-align: center;border-radius: 4px;position: fixed;top: 50%;left: 50%;transform: translate(-50%, -50%);z-index: 999999;background: rgba(0, 0, 0,.7);font-size: 16px;";
        document.body.appendChild(m);
        setTimeout(function () {
            let d = 0.5;
            m.style.webkitTransition = '-webkit-transform ' + d + 's ease-in, opacity ' + d + 's ease-in';
            m.style.opacity = '0';
            setTimeout(function () {
                document.body.removeChild(m)
            }, d * 1000);
        }, duration);
    }

    /**
     * @param { String } url 
     */
    var includeLinkStyle = function (url) {
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.type = "text/css";
        link.href = url;
        document.getElementsByTagName("head")[0].appendChild(link);
    }

    /**
     * 
     * @param { String } value 
     * @returns Boolean
     */
    var isMobileNumber = function (value) {
        value = value.replace(/[^-|\d]/g, '');
        return (
            /^((\+86)|(86))?(1)\d{10}$/.test(value) || /^0[0-9-]{10,13}$/.test(value)
        );
    }

    /**
     * @returns Boolean
     */
    var isMobile = function () {
        return window.innerWidth <= 1024;
    }

    /**
     * 
     * @param { String } str 
     * @returns void
     */
    var copyToClipboard = function (str, successText = 'Copy successfully!', failText = 'Copy failure!',needToast = true) {
        const el = document.createElement('textarea');
        el.value = str;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);

        const selection = document.getSelection();

        if (!selection) {
            return;
        }

        const selected = selection.rangeCount > 0 ? selection.getRangeAt(0) : false;

        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);

        if (selected) {
            selection.removeAllRanges();
            selection.addRange(selected);
            needToast && Toast(successText);
        } else {
            needToast && Toast(failText);
        }
    }

    /**
     * @param { Number } timestamp 
     * @returns  String
     */
    var getDateStr = function (timestamp) {
        var date = new Date(timestamp * 1000);
        var Y = date.getFullYear();
        var M = (date.getMonth() + 1).toString().padStart(2, '0');
        var D = date.getDate().toString().padStart(2, '0');
        return [Y, M, D].join('-');
    }

    var dateFormat = function (timestamp, format) {
        if (!timestamp) {
            return ''
        }
        let date = new Date(timestamp)
        const fullYear = date.getFullYear();
        const result = format.replace('YYYY', fullYear)
            .replace('YY', fullYear.toString().slice(-2))
            .replace('MM', (date.getMonth() + 1).toString().padStart(2, '0'))
            .replace('DD', date.getDate().toString().padStart(2, '0'))
            .replace('HH', date.getHours().toString().padStart(2, '0'))
            .replace('mm', date.getMinutes().toString().padStart(2, '0'))
            .replace('ss', date.getSeconds().toString().padStart(2, '0'))

        return result
    }

    function getCustomerId() {
        return getCookie('customer_id') || window.theme?.customer_id || '';
    };

    function getAccessToken() {
        const PROXY_TOKEN_STORAGE_KEY = 'mkProxyToken'
        return window.localStorage.getItem(PROXY_TOKEN_STORAGE_KEY) || '';
    }

    function isB2bCustomer() {
        if (window.makeblock && window.makeblock.customer && window.makeblock.customer.b2b) {
            return true;
        }
        return false;
    }

    /**
     * @returns  Object
     */
    var getSignatureHeader = function () {
        try {
            var timeStamp = Math.floor(Date.now().toString() / 1000);
            let secretKey = "7b141a46c423977f9d2dae3a0777cfa2";
            let sign_str = CryptoJS.MD5(timeStamp + ":" + secretKey).toString();
            let obj = {
                'Content-Type': 'application/json',
                'sign_str': sign_str,
                'time_stamp': timeStamp,
                'X-Mk-Shopify-Store': getStore(),
            };
            const customerId = getCustomerId();
            if (customerId) {
                obj['X-Mk-Shopify-Customer-ID'] = customerId
            }
            if (isB2bCustomer()) {
                const access_token =  getAccessToken()
                if(access_token) {
                    obj['X-Mk-Shopify-Session-Token'] = access_token
                }
            } else {
                const utoken = getCookie('utoken');
                if (utoken) {
                    obj['utoken']= utoken
                }
            }
            // if(customerId) {
            //     obj = {
            //         'sign_str': sign_str,
            //         'time_stamp': timeStamp,
            //         'X-Mk-Shopify-Store': getStore(),
            //         'X-Mk-Shopify-Customer-ID': getCustomerId(),
            //         'utoken': getCookie('utoken')
            //     }
            // }
            return obj
        } catch (error) {
            console.error('获取签名失败', error);
        }
    }

    /**
     * @returns xcc生产地址
     */
    var getXccApiDomain = function () {
        const shopName = getStore();
        if (['testxtool', 'wholesale-xtool-test'].includes(shopName)) {
            return '//dtc-api-test.xtool.com'
        }
        return '//dtc.mblock.cc'
    }

    var getStore = function () {
        return Shopify.shop.split('.')[0]
    }

    /**
     * 
     * @param { Number } endTimeTimestamp 
     * @param { Number } startTimeTimestamp 
     * @returns 
     */

    const countDown = function (params) {

        const {
            startTimeTimestamp,
            endTimeTimestamp,
            index
        } = params || {};

        if (params) {
            window.sessionStorage.setItem('startTimeTimestamp', startTimeTimestamp)
            window.sessionStorage.setItem('endTimeTimestamp', endTimeTimestamp)
            window.sessionStorage.setItem('countdownIndex', index)
        }

        let timer = null;
        let isExpired = false;
        const nowTime = new Date();
        const beginDiff = parseInt((!startTimeTimestamp ? window.sessionStorage.getItem('startTimeTimestamp') : startTimeTimestamp) * 1000 - nowTime.getTime());
        const endDiff = parseInt((!endTimeTimestamp ? window.sessionStorage.getItem('endTimeTimestamp') : endTimeTimestamp) * 1000 - nowTime.getTime());
        const leftTime = beginDiff > 0 ? beginDiff : endDiff;

        const day = parseInt(leftTime / (24 * 60 * 60 * 1000));
        const hour = parseInt(leftTime / (60 * 60 * 1000) % 24);
        const minute = parseInt(leftTime / (60 * 1000) % 60);
        const second = parseInt(leftTime / 1000 % 60);

        if (beginDiff > 0) {
            timer = setTimeout(countDown, 1000);
            isExpired = false;
        } else if (leftTime <= 0) {
            clearTimeout(timer);
            window.sessionStorage.removeItem('startTimeTimestamp');
            window.sessionStorage.removeItem('endTimeTimestamp');
            window.sessionStorage.removeItem('countdownIndex');
            isExpired = true;
        } else {
            $(`.count-down__wrapper-${!index ? window.sessionStorage.getItem('countdownIndex') : index} .hour-msg`).text(hour);
            $(`.count-down__wrapper-${!index ? window.sessionStorage.getItem('countdownIndex') : index} .mins-msg`).text(minute);
            $(`.count-down__wrapper-${!index ? window.sessionStorage.getItem('countdownIndex') : index} .secs-msg`).text(second);
            timer = setTimeout(countDown, 1000);
            isExpired = false;
        }

        return isExpired;
    }

    /**
     * 辅助函数，返回访问页面的设备类型（PC、Mobile、Pad）
     * @returns 'Pad' | 'Mobile' | 'PC'
     */
    const platform = function () {
        let ua = navigator.userAgent,
            isWindowsPhone = /(?:Windows Phone)/.test(ua),
            isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
            isAndroid = /(?:Android)/.test(ua),
            isFireFox = /(?:Firefox)/.test(ua),
            isChrome = /(?:Chrome|CriOS)/.test(ua),
            isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
            isPhone = /(?:iPhone)/.test(ua) && !isTablet,
            isPc = !isPhone && !isAndroid && !isSymbian;

        return isTablet ? 'Pad' : (isPhone || isAndroid) ? 'Mobile' : isPc ? 'PC' : 'PC';
    }

    /**
     * 解析地址栏参数，保存在params对象中
     * @returns url参数对象
     */
    const getQueryParams = function () {
        var query = location.search.substring(1)
        var arr = query.split('&')
        var params = {}
        for (var i = 0; i < arr.length; i++) {
            var pair = arr[i].split('=')
            params[pair[0]] = pair[1]
        }
        return params
    }

    /**
     * 兼容PC、移动端的点击事件
     */
    const tap = function (ele, callback) {
        if (this.platform() !== 'PC') {
            $(ele).on('touchstart', function (event) {
                callback(event);
            })
        } else {
            $(ele).on('click', function (event) {
                callback(event)
            })
        }
    }

    /** 动态创建script标签 */
    const loadScript = function (url, attr = {}, cb) {
        let script = document.createElement('script');
        script.src = url;
        Object.keys(attr).forEach(key => {
            script[key] = attr[key]
        })
        let firstScript = document.getElementsByTagName('script')[0];
        firstScript.parentNode.append(script, firstScript);

        // script 加载完毕后调用方法
        script.onload = script.onreadystatechange = function () {
            if (!this.readyState     //这是FF的判断语句，因为ff下没有readyState这个值，IE的readyState肯定有值
                || this.readyState == 'loaded' || this.readyState == 'complete'   // 这是IE的判断语句
            ) {
                cb && cb()
            }
        };
    }


    var listeners = [];
    var doc = document;
    var observer;
    function observerEleReady(selector, fn) {
        // 储存选择器和回调函数
        listeners.push({
            selector: selector,
            fn: fn
        });
        if (!observer) {
            // 监听document变化
            observer = new MutationObserver(check);
            observer.observe(doc.documentElement, {
                childList: true,
                subtree: true
            });
        }
        // 检查该节点是否已经在DOM中
        check();
    }

    function check() {
        // 检查是否匹配已储存的节点
        for (var i = 0; i < listeners.length; i++) {
            var listener = listeners[i];
            // 检查指定节点是否有匹配
            var elements = document.querySelectorAll(listener.selector);
            for (var j = 0; j < elements.length; j++) {
                var element = elements[j];
                // 确保回调函数只会对该元素调用一次
                if (!element.ready) {
                    element.ready = true;
                    // 对该节点调用回调函数
                    listener.fn.call(element, element);
                }
            }
        }
    }

    function firstWordToUpperCase(word) {
        return word.slice(0, 1).toLocaleUpperCase() + word.slice(1)
    }

    function exceptionNotification(errTitle = '异常提示"', errorMsg = '') {
        getIpLocation().then((countryName) => {
            const message = createFeishuMessage(errTitle, countryName, errorMsg);
            sendFeishuMessage(message);
        });

        function getHeaders() {
            var headers = {};
            for (var key in navigator) {
                if (
                    key.indexOf("appVersion") !== -1 ||
                    key.indexOf("userAgent") !== -1 ||
                    key.indexOf("platform") !== -1
                ) {
                    headers[key] = navigator[key];
                }
            }
            return headers;
        }

        function getIpLocation() {
            return fetch("https://dtc.mblock.cc/shopify/ip", { method: "GET" })
                .then((response) => response.json())
                .then((res) => {
                    return res.data.country_name;
                });
        }

        function createFeishuMessage(title, countryName, error = '') {
            return JSON.stringify({
                msg_type: "post",
                content: {
                    post: {
                        zh_cn: {
                            title: title,
                            content: [
                                [
                                    {
                                        tag: "text",
                                        text: `ip: - ${countryName}\n`,
                                    },
                                    {
                                        tag: "text",
                                        text: `请求头: ${JSON.stringify(
                                            getHeaders()
                                        )}\n`,
                                    },
                                    {
                                        tag: "text",
                                        text: `用户id: ${window.theme.customer_id}\n`,
                                    },
                                    {
                                        tag: "text",
                                        text: `${error}\n`,
                                    },
                                    {
                                        tag: "text",
                                        text: `href: ${window.location.href}\n`,
                                    },

                                ],
                            ],
                        },
                    },
                },
            });
        }

        function sendFeishuMessage(message) {
            const feishuBot = `https://open.feishu.cn/open-apis/bot/v2/hook/4ef03b5d-6743-4a0f-a4c0-eaa5ae322600`;
            fetch(feishuBot, {
                method: "POST",
                body: `${message}`,
            });
        }
    }


    function fetchFeishuMessage(feishuBot, message) {
        fetch(feishuBot, {
            method: 'POST',
            mode: 'no-cors', //加这个字段才可以在浏览器里面直接发起ajax请求
            headers: {
            'Content-Type': 'application/json',
            },
            body: JSON.stringify(message),
        });
    }

    // 飞书通知优化版本
    function feishuNotification(config) {
        // 配置
        var baseConfig = {
          errorTitle: '异常提示', //错误title，便于区分错误类别
          isTest: false, //是否是测试，测试的话，不会执行飞书通知
          errorMsg: '', //错误详细信息
          errorLevel: 1, //报警级别，默认1级
          responsiblePerson: '', //错误负责人
          feishuBot:
            'https://open.feishu.cn/open-apis/bot/v2/hook/4ef03b5d-6743-4a0f-a4c0-eaa5ae322600', //上报的飞书群webhook
          errorResolvePage:
            'https://makeblock.feishu.cn/wiki/AwRwwlgVLig9WAktt3Pcq9Wlnod?table=tblCsC7OcLAAsJSJ&view=vew2op0261', //上报的飞书群错误处理文档
          feishutTemplateId: 'ctp_AA1WWaWGD6hU', //上报的飞书群消息卡片,可在搭建工具中通过"复制卡片ID"获取
        };
        var finalConfig = {};
        function mergeConfig(baseConfig, config) {
          if (!config || !config.errorMsg) {
            return;
          }
          for (var key in config) {
            if (Object.prototype.hasOwnProperty.call(config, key)) {
              if (key === 'isTest') {
                baseConfig[key] =
                  config[key] === undefined ? baseConfig[key] : config[key];
              } else {
                baseConfig[key] = config[key] || baseConfig[key];
              }
            }
          }
          return baseConfig;
        }
        try {
          finalConfig = mergeConfig(baseConfig, config) || {};
          if (
            finalConfig === null || finalConfig === void 0
              ? void 0
              : finalConfig.isTest
          ) {
            return;
          }
        } catch (e) {
          console.info('mergeConfig报错', e);
          return;
        }
        var submitErrorUids = []; //错误去重过滤
        Promise.resolve(getIpLocation()).then(function (countryName) {
          var message = createFeishuMessage(finalConfig, countryName);
          sendFeishuMessage(message);
        });
        function getHeaders() {
          var headers = {};
          for (var key in navigator) {
            if (
              key.indexOf('appVersion') !== -1 ||
              key.indexOf('userAgent') !== -1 ||
              key.indexOf('platform') !== -1
            ) {
              headers[key] = navigator[key];
            }
          }
          return headers;
        }
        function getIpLocation() {
          try {
            // 读取数据时检查过期时间
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            var storedData = JSON.parse(localStorage.getItem('feishuPostIps'));
            if (storedData && storedData.expiration > new Date().getTime()) {
              return storedData.data.dtcStationCountryName;
            } else {
              return fetch('https://dtc.mblock.cc/shopify/ip', { method: 'GET' })
                .then(function (response) {
                  return response.json();
                })
                .then(function (res) {
                  // 存储数据和过期时间
                  var data = { dtcStationCountryName: res.data.country_name };
                  var expiration = new Date().getTime() + 3600000 * 24; // 设置过期时间为1天（以毫秒为单位）
                  localStorage.setItem(
                    'feishuPostIps',
                    JSON.stringify({ data: data, expiration: expiration }),
                  );
                  return res.data.country_name;
                });
            }
          } catch (error) {
            console.info('getIpLocation报错', e);
            return '';
          }
        }
        function createFeishuMessage(finalConfig, countryName) {
          var _a, _b, _c, _d, _e, _f, _g, _h;
          return {
            msg_type: 'interactive',
            card: {
              type: 'template',
              data: {
                template_id: finalConfig.feishutTemplateId,
                template_variable: {
                  errorMsg: finalConfig.errorMsg,
                  responsiblePerson: finalConfig.responsiblePerson,
                  station: window.location.hostname,
                  pageUrl: window.location.href,
                  ip: countryName,
                  requestHeader: ''.concat(JSON.stringify(getHeaders())),
                  userId:
                    (_b =
                      (_a =
                        window === null || window === void 0
                          ? void 0
                          : window.makeblock) === null || _a === void 0
                        ? void 0
                        : _a.customer) === null || _b === void 0
                      ? void 0
                      : _b.id,
                  userEmail:
                    (_d =
                      (_c =
                        window === null || window === void 0
                          ? void 0
                          : window.makeblock) === null || _c === void 0
                        ? void 0
                        : _c.customer) === null || _d === void 0
                      ? void 0
                      : _d.email,
                  errorLevel: finalConfig.errorLevel,
                  errorTitle: finalConfig.errorTitle,
                  errorResolvePage: finalConfig.errorResolvePage,
                  errorEnv: ''
                    .concat(
                      (_f =
                        (_e =
                          window === null || window === void 0
                            ? void 0
                            : window.Shopify) === null || _e === void 0
                          ? void 0
                          : _e.theme) === null || _f === void 0
                        ? void 0
                        : _f.name,
                      ',role:',
                    )
                    .concat(
                      (_h =
                        (_g =
                          window === null || window === void 0
                            ? void 0
                            : window.Shopify) === null || _g === void 0
                          ? void 0
                          : _g.theme) === null || _h === void 0
                        ? void 0
                        : _h.role,
                    ),
                },
              },
            },
          };
        }
        // 初始化上报方法
        function sendFeishuMessage(message) {
          try {
            // const hasSubmitErrorStatus = hasSubmitError(message);
            // if (hasSubmitErrorStatus) return;
            return typeof navigator.sendBeacon === 'function'
              ? beaconTransport(message)
              : fetchSendMessage(message);
          } catch (e) {
            console.info('sendFeishuMessage报错', e);
          }
        }
        // beacon 形式上报
        function beaconTransport(message) {
          var status = window.navigator.sendBeacon(
            finalConfig.feishuBot,
            JSON.stringify(message),
          );
          // 如果数据量过大，则本次大数据量用 fetchSendFeishuMessage 上报
          if (!status) fetchSendMessage(message);
        }
        function fetchSendMessage(message) {
            fetchFeishuMessage(finalConfig.feishuBot, message);
        }
    }

    function feishuSendInteractiveMessage(config) {
        const { body, header, feishuBot } = config;
        const message = {
            msg_type: "interactive",
            card: {
                schema: "2.0",
                config: {
                    update_multi: true,
                    style: {
                        text_size: {
                            normal_v2: {
                                default: "normal",
                                pc: "normal",
                                mobile: "heading",
                            },
                        },
                    },
                },
                body,
                header,
            },
        };
        fetchFeishuMessage(feishuBot, message);
    }
    // 设置cookie，seconds以秒为单位
    function setCookie(name, value, seconds) {
        var expires = "";
        if (seconds) {
            var date = new Date();
            date.setTime(date.getTime() + seconds * 1000);
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    // 获取cookie
    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    // 移除cookie
    function deleteCookie(name) {
        document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/;';
    }

    function checkEmail(value) {
        var pattern = /^([A-Za-z0-9_\-\.\+])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,8})$/;
        return pattern.test(value);
    };


    // 获取顶部的高度(header+topbar)
    function getHeaderFixedHeight() {
        const topbar = $('#topbar');
        const header = $('.header-nav');
        // const topbarHeight = topbar.height() || 0;
        const topbarHeight = 0;
        const headerHeight = header.height() || 0;

        const productPage = isProductPage();
        if (window.innerWidth > 1024 || window.scrollY === 0) {
            return productPage ? topbarHeight : topbarHeight + headerHeight;
        } else {
            return productPage ? 0 : headerHeight;
        }
    }


    // 判断是否在可视区域
    function isElementInViewport(el) {
        if (!el) {
            return false;
        }
        // 获取元素是否在可视区域
        var rect = el.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <=
            (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <=
            (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    /*
    ** header导航栏阴影更新逻辑
    ** @params: otherFixedNode: 依赖页面其他固定节点，如果页面滚动中有其他节点需要固定，阴影需要隐藏
    */

    function updateHeaderShadow(otherFixedNode) {
        if ($('body').hasClass('position-fixed')) return;
        let top = 0;
        const headerHeight = getHeaderFixedHeight();
        if (otherFixedNode) {
            top = otherFixedNode.getBoundingClientRect().top;
        }
        if (window.scrollY > 20 && (!top || top > headerHeight)) {
            $('.header-nav').addClass('shadow');
        } else {
            $('.header-nav').removeClass('shadow');
        }
    }

    function updateHeaderFixedState() {
        const navContent = $('#main-menu-mobile-v2');
        // 手机端导航展开时，不执行该逻辑
        if (isProductPage() || navContent?.hasClass('isOpen')) return;
        if ($('body').hasClass('position-fixed')) return;
        if (window.innerWidth <= 1024) {
            if (window.scrollY > 0) {
                $('.header-nav').addClass('header-section--fold-topbar');
                $('.topbar').addClass('topbar--fold-topbar');
                $('#MainContent').addClass('main-content--fold-topbar')
                // $('.topbar-container').addClass('topbar--hide');
            } else {
                $('.header-nav').removeClass('header-section--fold-topbar');
                $('.topbar').removeClass('topbar--fold-topbar');
                $('#MainContent').removeClass('main-content--fold-topbar')
                // $('.topbar-container').removeClass('topbar--hide');
            }
        }
    }

    function isProductPage() {
        return window.location.pathname.indexOf('/products/') === 0
    }

    function getSectionByName(sectionName) {
        if (!sectionName || typeof sectionName != 'string') {
            return '';
        }
        sectionName = sectionName.split(',').filter(t => t != '').join(',');  // 过滤 ssss,  这样的格式
        const len = sectionName.split(',').length;
        return fetch(window.Shopify.routes.root + `?sections=${sectionName}`)
            .then(res => res.json())
            .then(res => {
                return len > 1 ? res : res[sectionName];
            }).catch(() => {
                throw new Error();
            })
    }
    function scrollIntoView(ele) {
        if (!ele) {
            return;
        }
        const elePosTop = ele.getBoundingClientRect().top;
        const headerHeight = __Xtool_Utils.getHeaderFixedHeight();  // 顶部的高度(header+topbar)
        const eleTarPosTop = elePosTop + window.pageYOffset - headerHeight; // 目标top
        window.scrollTo({ top: eleTarPosTop, behavior: "smooth" });
    }
    function getEmarsysCustomerId(email, store) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: "https://dtc.mblock.cc/xtool-creators-club/v1/customers/id",
                type: "GET",
                headers: getSignatureHeader(),
                data: {
                    store,
                    email
                }
            }).done(function (response) {
                if (response.code === 0 && response.data && response.data.id) {
                    resolve(response.data.id);
                }
            })
        })
    }

    function t(path) {
        const keys = path.split('.');
        let value = window.global_locales;
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            if (value && typeof value === 'object' && key in value) {
                value = value[key];
            } else {
                return undefined;
            }
        }
        return value;
    }

    /**
     * 懒加载 图片、视频
     * @param {Object} options
     * @param {Element | Element[]} options.target - 目标元素
     * @param {IntersectionObserverInit=} options.observerOptions - IntersectionObserver的参数
     * @param {string=} options.sourceAttr - 源属性，默认为src
     * @param {string | string[] | undefined} options.replaceAttr - 替换属性，默认为data-src,如果是数组，则会找到第一个有值的属性替换
     * @param {{sourceAttr:string,replaceAttr:string | string[]}[]=} options.batchAttrOptions - 批量替换属性 该属性存在时，会忽略上面的sourceAttr、replaceAttr
     */
    const lazyLoad = (options) => {
        let { target, observerOptions, sourceAttr = 'src', replaceAttr = 'data-src', batchAttrOptions } = options;
        let finalAttrOptions = batchAttrOptions || [{ sourceAttr, replaceAttr: replaceAttr }];
        if (!target) return;
        if (!target.forEach) {
            target = [target]
        }
        if (!target.length) return;
        // 加载资源
        const loadResource = (element) => {
            // 判断是否为picture标签、video标签、audio标签,如果是的话，需要连带替换source的属性
            const tagName = element.tagName.toLowerCase();
            let targetEle = [element];
            if (['video', 'audio', 'picture'].includes(tagName)) {
                const sourceEle = element.querySelectorAll('source') || [];
                const imgEle = element.querySelectorAll('img') || [];

                targetEle = targetEle.concat([...sourceEle, ...imgEle]);
            }
            targetEle.forEach(function (ele) {
                // 替换属性
                finalAttrOptions.forEach(function (item) {
                    const { sourceAttr, replaceAttr } = item;
                    let replaceAttrVal = '', replaceAttrArr = replaceAttr;
                    if (!Array.isArray(replaceAttr)) {
                        replaceAttrArr = [replaceAttr];
                    }
                    // 找到第一个有值的属性替换
                    replaceAttrArr.some(function (attr) {
                        replaceAttrVal = ele.getAttribute(attr);
                        return replaceAttrVal;
                    })
                    // 都没有值则return
                    if (!replaceAttrVal) return;
                    ele[sourceAttr] = replaceAttrVal;
                })
            })
        }
        const observerCallback = (entries, observer) => {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    // 进入可视区域，加载图片资源
                    const ele = entry.target;
                    loadResource(ele);
                    // 停止监听
                    observer.unobserve(ele);
                }
            });
        }
        const observer = new IntersectionObserver(observerCallback, observerOptions || { rootMargin: '0px', threshold: 0 });
        target.forEach(function (item) {
            observer.observe(item);
        })

        return observer;
    }
  
    function getCurrentVariant(params) {
        const queryParams = getQueryParams();
        const variantId = queryParams.variant;
        const variantList = window?.makeblock?.product?.variants;
        const result = variantList.find((item) => String(item.id) === variantId) || window?.makeblock?.product?.selected_or_first_available_variant;
        return result;
    }

    function throttle(func, delay) {
        let lastCall = 0;
        return function(...args) {
            const now = (new Date).getTime();
            if (now - lastCall >= delay) {
                lastCall = now;
                return func.apply(this, args);
            }
        };
    }


    /**
     * 
     * @param {object} params 
     * @param {string} params.name - abtest名称
     * @param {string|boolean|number} params.defaultValue - 默认值
     * @param {function} params.callback - 回调函数
     * @returns 
     */
    const fetchPtABTest = (params)=>{
        const {defaultValue,name,callback} = params;
        // 如果已经有值，直接返回
        if(window.ptABTest && window.ptABTest[name]!== undefined){
            callback(window.ptABTest[name] && window.ptABTest[name].value);
            return;
        }
        // 监听事件
        document.addEventListener(name, function (e) {
            const value = e.detail && e.detail.value;
            callback(value);
        });
    }

    // 编码
    function encode (str) {
        if (!str) return '';
        const encoder = new TextEncoder();
        const bytes = encoder.encode(str);
        return btoa(String.fromCharCode(...bytes));
    }

    // 封装fetch请求
    function fetchJSON(url, options = {}) {
        var headers = getSignatureHeader();
        options.headers = headers;
        return new Promise((resolve, reject) => {
            window.fetch(url, options)
                .then(res => {
                    if (!res.ok) {
                        throw new Error(`请求失败: ${res.status} ${res.statusText}`);
                    }
                    return res.json();
                })
                .then(resolve)
                .catch(reject);
        });
    }

    const DATE_FORMAT = {
        testxtool: {
          DATE: 'MM/DD/YYYY',
          DATE_TIME: 'MM/DD/YYYY HH:mm:ss',
        },
        'makeblock-xtool': {
          DATE: 'MM/DD/YYYY',
          DATE_TIME: 'MM/DD/YYYY HH:mm:ss',
        },
        'xtool-australia-store': {
          DATE: 'DD/MM/YYYY',
          DATE_TIME: 'DD/MM/YYYY HH:mm:ss',
        },
        'wholesale-xtool-test': {
          DATE: 'MM/DD/YYYY',
          DATE_TIME: 'MM/DD/YYYY HH:mm:ss',
        },
        'ca-xtool': {
          DATE: 'YYYY-MM-DD',
          DATE_TIME: 'YYYY-MM-DD HH:mm:ss',
        },
        'eu-xtool': {
          DATE: 'DD/MM/YYYY',
          DATE_TIME: 'DD/MM/YYYY HH:mm:ss',
        },
        // todo 未处理完
        'uk-xtool': {
          DATE: 'DD/MM/YYYY',
          DATE_TIME: 'DD/MM/YYYY hh:mm:ss a',
        },
        'de-xtool': {
          DATE: 'DD/MM/YYYY',
          DATE_TIME: 'DD/MM/YYYY HH:mm:ss',
        },
        'fr-xtool': {
          DATE: 'DD/MM/YYYY',
          DATE_TIME: 'DD/MM/YYYY HH:mm:ss',
        },
        'jp-xtool': {
          DATE: 'YYYY-MM-DD',
          DATE_TIME: 'YYYY-MM-DD HH:mm:ss',
        },
        'cool-gadget-4015': {
          DATE: 'MM/DD/YYYY',
          DATE_TIME: 'MM/DD/YYYY HH:mm:ss',
        },
        makeblock: {
          DATE: 'MM/DD/YYYY',
          DATE_TIME: 'MM/DD/YYYY HH:mm:ss',
        },
        default: {
          DATE: 'MM/DD/YYYY',
          DATE_TIME: 'MM/DD/YYYY HH:mm:ss',
        },
      };
      

    // 根据时间戳、时区返回时间，时间格式为：YYYY-MM-DD HH:mm:ss
    const getDateTimeStr = (timestamp, shopTimeZone) => {
        const shop = window.Shopify.shop.split('.')[0];
        // 默认当前系统时间戳
        let shopTimestamp = dayjs().valueOf();
        if (timestamp) {
            shopTimestamp = timestamp;
        }
        let dateFormat = DATE_FORMAT[shop];
        if (!dateFormat) {
            dateFormat = DATE_FORMAT.default;
        }
        // 转换为店铺时区的时间字符串，时间格式化
        const time = dayjs(shopTimestamp).tz(shopTimeZone).format(dateFormat.DATE_TIME);
        // 获取时区偏移量
        const offset = dayjs().tz(shopTimeZone).utcOffset();
        // 获取时区偏移量对应的GTM偏移
        const offsetGTM = offset / 60;
        return `${time} (GMT${offset > 0 ? '+' : ''}${offsetGTM})`;
  };

    /**
     * 计算商品阶梯折扣
     * @param {number} price - 商品价格（单位：元）
     * @param {Array} ladderDiscountRules - 阶梯折扣规则数组
     * @returns {number} 折扣金额（单位：元）
     */
    var calculateLadderDiscount = function(price, ladderDiscountRules) {
        if (!Array.isArray(ladderDiscountRules) || ladderDiscountRules.length === 0) {
            return 0;
        }

        // 按价格从小到大排序
        var sortedRules = ladderDiscountRules.slice().sort(function(a, b) {
            return a.price - b.price;
        });
        
        var discount = 0;
        for (var i = 0; i < sortedRules.length; i++) {
            if (price >= sortedRules[i].price) {
                discount = sortedRules[i].discount;
            }
        }

        return discount;
    };

    /**
     * 检查变体ID是否符合配置规则
     * @param {string|number} variantId - 变体ID
     * @param {Array} includeList - 包含列表
     * @param {Array} excludeList - 排除列表
     * @returns {boolean} 是否符合规则
     */
    var isVariantAllowed = function(variantId, includeList, excludeList) {
        if (!variantId) return true;
        
        var variantIdStr = String(variantId);
        
        // 检查排除列表
        if (Array.isArray(excludeList) && excludeList.length > 0) {
            for (var i = 0; i < excludeList.length; i++) {
                if (String(excludeList[i]) === variantIdStr) {
                    return false; // 在排除列表中，不允许
                }
            }
        }
        
        // 检查包含列表
        if (Array.isArray(includeList) && includeList.length > 0) {
            // 如果包含列表第一个元素为空字符串，表示包含所有
            if (includeList[0] === "" || includeList[0] === null) {
                return true;
            }
            // 否则检查是否在包含列表中
            for (var j = 0; j < includeList.length; j++) {
                if (String(includeList[j]) === variantIdStr) {
                    return true;
                }
            }
            return false; // 不在包含列表中，不允许
        }
        
        return true; // 没有限制，允许
    };

    /**
     * 获取商品类型对应的阶梯折扣配置
     * @param {string} productType - 商品类型
     * @param {string|number} [variantId] - 变体ID
     * @returns {Object|null} 阶梯折扣配置对象
     */
    var getLadderDiscountConfig = function(productType, variantId) {
        var productLadderDiscount = window.makeblock && window.makeblock.final_price_product_ladder_discount || [];
        
        // 优先检查全局配置（没有type的配置）
        if (variantId) {
            for (var i = 0; i < productLadderDiscount.length; i++) {
                var config = productLadderDiscount[i];
                // 全局配置：没有type字段，通过include_variant_id匹配
                if (!config.type && config.include_variant_id) {
                    if (config.include_variant_id.includes(String(variantId))) {
                        return config;
                    }
                }
            }
        }
        
        // 检查产品类型配置（有type的配置）
        for (var i = 0; i < productLadderDiscount.length; i++) {
            var config = productLadderDiscount[i];
            if (config.type === productType) {
                // 检查变体ID是否被排除
                if (variantId && config.exclude_variant_id && config.exclude_variant_id.includes(String(variantId))) {
                    continue; // 变体ID被排除，跳过
                }
                return config;
            }
        }
        
        return null;
    };

    /**
     * 检查是否为特殊商品（不参与到手价计算）
     * @param {Array} productTags - 商品标签数组
     * @returns {boolean}
     */
    var isSpecialProduct = function(productTags) {
        return productTags.includes('SMB Special');
    };

    /**
     * 检查是否为耗材商品
     * @param {string} productType - 商品类型
     * @returns {boolean}
     */
    var isMaterialProduct = function(productType) {
        return productType === (window._shopifyProductPageSetting && window._shopifyProductPageSetting.productType && window._shopifyProductPageSetting.productType.material);
    };

    /**
     * 计算耗材特殊价格（8折）
     * @param {number} price - 原价格（单位：元）
     * @param {number} carePrice - Care价格（单位：元，默认为0）
     * @returns {number} 计算后的价格（单位：元）
     */
    var calculateMaterialPrice = function(price, carePrice) {
        carePrice = carePrice || 0;
        return (price - carePrice) * 0.8 + carePrice;
    };

    /**
     * 价格单位转换：分转元
     * @param {number} priceInCents - 价格（单位：分）
     * @returns {number} 价格（单位：元）
     */
    var centsToYuan = function(priceInCents) {
        return priceInCents / 100;
    };

    /**
     * 价格单位转换：元转分
     * @param {number} priceInYuan - 价格（单位：元）
     * @returns {number} 价格（单位：分）
     */
    var yuanToCents = function(priceInYuan) {
        return priceInYuan * 100;
    };

    /**
     * 计算百分比折扣后的价格
     * @param {number} price - 原价格（单位：元）
     * @param {number} percentage - 折扣百分比（0.1表示9折）
     * @returns {number} 折扣后价格（单位：元）
     */
    var calculatePercentageDiscount = function(price, percentage) {
        if (!percentage || percentage <= 0) {
            return price;
        }
        
        // 预估到手价 = 售价 * (1 - 折扣百分比)
        var discountedPrice = price * (1 - percentage);
        
        // 保留两位小数，第二位小数进1
        return roundUpToTwoDecimals(discountedPrice);
    };

    /**
     * 价格保留到两位小数，第三位有值则向上进1
     * @param {number} price - 原价格
     * @returns {number} 处理后的价格
     */
    var roundUpToTwoDecimals = function(price) {
        // 保留两位小数，如果第三位有值则第二位向上进1
        // 例如：75.991 → 76.00，75.992 → 76.00，75.990 → 75.99
        // 为了避免浮点数精度问题，先将价格乘以1000取整，判断第三位
        var priceIn1000 = Math.round(price * 1000);
        var priceIn100 = Math.ceil(priceIn1000 / 10);
        return priceIn100 / 100;
    };

    /**
     * 核心价格和折扣计算函数
     * @param {Object} params - 计算参数
     * @param {string} params.productType - 商品类型
     * @param {Array} params.productTags - 商品标签数组
     * @param {number} params.price - 商品价格（单位：分）
     * @param {number} [params.carePrice=0] - Care价格（单位：元）
     * @param {number} [params.compareAtPrice] - 划线价（单位：分），用于计算总折扣
     * @param {string|number} [params.variantId] - 变体ID，用于精确匹配配置
     * @returns {Object} 计算结果
     */
    /**
     * 计算产品价格和折扣（支持阶梯折扣和百分比折扣）
     * @param {Object} params - 参数对象
     * @param {string} params.productType - 产品类型
     * @param {Array} params.productTags - 产品标签
     * @param {number} params.price - 价格（单位：分）
     * @param {number} params.carePrice - Care价格（可选，单位：分）
     * @param {number} params.compareAtPrice - 对比价格（可选，单位：分）
     * @param {string|number} params.variantId - 变体ID
     * @returns {Object} 计算结果
     */
    var calculatePriceAndDiscount = function(params) {
        var productType = params.productType;
        var productTags = params.productTags;
        var priceInCents = params.price;
        var carePrice = params.carePrice || 0;
        var compareAtPrice = params.compareAtPrice || 0;
        var variantId = params.variantId;
        // 直接从全局变量读取 showPromotionInfo，默认为 true
        var showPromotionInfo = (window.makeblock && window.makeblock.customer && window.makeblock.customer.show_promotion_info !== false) ? true : false;

        // 初始化返回值（只返回核心计算结果）
        var result = {
            originalPrice: priceInCents,           // 原价格（分）
            finalPrice: priceInCents,              // 最终到手价（分）
            ladderDiscount: 0,                     // 阶梯折扣金额（分）
            percentageDiscount: 0,                 // 百分比折扣金额（分）
            totalDiscount: 0,                      // 总折扣金额（分，相对于划线价或原价）
            isSpecialProduct: false,               // 是否特殊商品
            isMaterialProduct: false,              // 是否耗材
            ladderDiscountConfig: null,            // 阶梯折扣配置
            minPrice: priceInCents,                // 最小价格（分）
            maxPrice: priceInCents,                // 最大价格（分）
            discountPercentage: 0,                 // 折扣百分比（0-100之间，如15表示15%折扣）
            usePercentageDisplay: false,           // 是否使用百分比展示（耗材为true，其他为false）
            
            // 新增：对比价相关折扣信息
            compareAtDiscount: 0,                  // 售价与对比价的折扣金额（分）
            compareAtDiscountPercentage: 0,        // 售价与对比价的折扣百分比
            
            // 新增：预估到手价相关折扣信息
            estimatedDiscount: 0,                  // 售价与预估到手价的折扣金额（分）
            estimatedDiscountPercentage: 0,         // 售价与预估到手价的折扣百分比
            hasFinalPrice: false,                  // 是否最终到手价
        };
        try {
            // 检查是否为特殊商品
            if (productTags && productTags.length > 0) {
                result.isSpecialProduct = isSpecialProduct(productTags);
            }
            // 检查是否为耗材
            result.isMaterialProduct = isMaterialProduct(productType);
            // 设置是否使用百分比展示：耗材使用百分比展示
            result.usePercentageDisplay = result.isMaterialProduct;
            // 获取阶梯折扣配置（支持变体ID匹配）
            var ladderDiscountConfig = getLadderDiscountConfig(productType, variantId);
            result.ladderDiscountConfig = ladderDiscountConfig;
            if (result.isSpecialProduct || !ladderDiscountConfig || !ladderDiscountConfig.enable) {
                if (compareAtPrice > 0 && compareAtPrice > result.originalPrice) {
                    result.maxPrice = compareAtPrice;
                    result.minPrice = result.originalPrice;
                    // 折扣百分比保留一位小数，向上取整
                    result.discountPercentage = Math.ceil(((result.maxPrice - result.minPrice) / result.maxPrice) * 1000) / 10;
                    result.totalDiscount = compareAtPrice - result.originalPrice;
                    
                    // 计算对比价折扣信息
                    result.compareAtDiscount = compareAtPrice - result.originalPrice;
                    result.compareAtDiscountPercentage = result.discountPercentage;
                }

                return result;
            }

            // 转换价格单位：分转元
            var price = centsToYuan(priceInCents);

            var finalPriceInYuan = price;
            var percentageDiscountAmount = 0;
            
            // if (result.isMaterialProduct) {
            //     // 耗材特殊处理：8折，不再走其他折扣逻辑
            //     finalPriceInYuan = calculateMaterialPrice(price, carePrice);
            //     result.finalPrice = yuanToCents(finalPriceInYuan);
            // } else {
                // 处理百分比折扣或阶梯折扣
                if (ladderDiscountConfig.percentage && ladderDiscountConfig.percentage > 0) {
                    // 使用百分比折扣：预估到手价 = 售价 * (1 - 折扣百分比)
                    finalPriceInYuan = calculatePercentageDiscount(price, ladderDiscountConfig.percentage);
                    percentageDiscountAmount = price - finalPriceInYuan;
                    
                    // 转换回分单位，并使用 Math.round 避免浮点数精度问题
                    result.finalPrice = Math.round(yuanToCents(finalPriceInYuan));
                    result.percentageDiscount = Math.round(yuanToCents(percentageDiscountAmount));
                    
                } else {
                    // 使用阶梯折扣
                    var ladderDiscountInYuan = calculateLadderDiscount(price, ladderDiscountConfig.discount);
                    
                    // 计算最终价格
                    finalPriceInYuan = price - ladderDiscountInYuan;
                    
                    // 转换回分单位，并使用 Math.round 避免浮点数精度问题
                    result.finalPrice = Math.round(yuanToCents(finalPriceInYuan));
                    result.ladderDiscount = Math.round(yuanToCents(ladderDiscountInYuan));
                }
            // }

            // 计算对比价相关折扣（如果有对比价）
            if (compareAtPrice > 0 && compareAtPrice > result.originalPrice) {
                result.compareAtDiscount = compareAtPrice - result.originalPrice;
                // 折扣百分比保留一位小数，向上取整
                result.compareAtDiscountPercentage = Math.ceil((result.compareAtDiscount / compareAtPrice) * 1000) / 10;
            }
            
            // 计算预估到手价相关折扣（如果有预估到手价优惠）
            if (result.finalPrice < result.originalPrice) {
                // 使用 Math.round 确保折扣金额是整数
                result.estimatedDiscount = Math.round(result.originalPrice - result.finalPrice);
                // 折扣百分比保留一位小数，向上取整
                result.estimatedDiscountPercentage = Math.ceil((result.estimatedDiscount / result.originalPrice) * 1000) / 10;
            }

            // 根据 showPromotionInfo 决定如何计算 totalDiscount
            if (showPromotionInfo) {
                // 显示预估到手价：从到手价、售价、对比价中找出最大值和最小值
                var prices = [result.finalPrice, result.originalPrice];
                result.minPrice = Math.min.apply(Math, prices);
                if (compareAtPrice > 0) {
                    prices.push(compareAtPrice);
                }
                result.maxPrice = Math.max.apply(Math, prices);
                // 计算总折扣（节省金额）= 最高价 - 最低价
                result.totalDiscount = result.maxPrice - result.minPrice;
            } else {
                // 不显示预估到手价：只考虑对比价和售价的折扣
                if (compareAtPrice > 0 && compareAtPrice > result.originalPrice) {
                    result.maxPrice = compareAtPrice;
                    result.minPrice = result.originalPrice;
                    result.totalDiscount = result.compareAtDiscount;
                    result.estimatedDiscount = 0;
                    result.estimatedDiscountPercentage = 0;
                } else {
                    // 如果没有对比价或对比价不大于售价，totalDiscount 为 0
                    result.maxPrice = result.originalPrice;
                    result.minPrice = result.originalPrice;
                    result.totalDiscount = 0;
                    result.estimatedDiscount = 0;
                    result.estimatedDiscountPercentage = 0;
                }
            }
            
            // 计算折扣百分比 = (最大价格 - 最小价格) / 最大价格 * 100，保留一位小数，四舍五入
            if (result.maxPrice > 0 && result.maxPrice > result.minPrice) {
                result.discountPercentage = Math.round(((result.maxPrice - result.minPrice) / result.maxPrice) * 1000) / 10;
            } else {
                result.discountPercentage = 0;
            }
            if(result.finalPrice !== result.originalPrice) {
                result.hasFinalPrice = true;
            }
            return result;

        } catch (error) {
            console.error('价格计算出错:', error);
            return result;
        }
    };


    function openBotModal() {
        const botIcon = document.querySelector('#mk-bot-icon')
        if (botIcon) {
            botIcon.click()
        }
    }

    /**
     * 获取 Money Off 标签文案（根据产品类型返回不同文案）
     * @param {string} productType - 产品类型
     * @param {number} discountAmount - 折扣金额（单位：分）或折扣百分比（耗材），如果为 null 则返回模板
     * @param {string} moneyFormat - 货币格式（可选，默认使用 theme.moneyFormat）
     * @returns {string} 格式化后的 off 标签文案或模板（带 {{money}} 占位符）
     */
    var getOffLabelText = function(productType, discountAmount, moneyFormat) {
        // 判断是否为耗材产品
        var isMaterial = isMaterialProduct(productType);
        
        // 根据产品类型选择不同的翻译键
        var translationKey = isMaterial 
            ? 'products.package_label.material_off' 
            : 'products.package_label.Off';
        
        // 获取翻译模板
        var labelTemplate = t(translationKey) || '{{money}} Off';
        
        // 如果没有提供折扣金额或金额为0，返回模板
        if (discountAmount == null || discountAmount <= 0) {
            return labelTemplate;
        }
        
        // 根据产品类型格式化折扣
        var formattedDiscount;
        if (isMaterial) {
            // 耗材：discountAmount 是百分比，直接显示数字，不格式化金额符号
            formattedDiscount = discountAmount.toLocaleString(`${Shopify.locale}-${Shopify.country}`);
        } else {
            // 非耗材：discountAmount 是金额（分），格式化为货币
            var format = moneyFormat || (window.theme && window.theme.moneyFormat) || '${{amount}}';
            formattedDiscount = Shopify.formatMoney(discountAmount, format);
        }
        
        return labelTemplate.replace('{{money}}', formattedDiscount);
    };

    /**
     * 计算所有商品的总折扣金额
     * @param {Array|Object} priceList - 价格列表数组或单个价格对象
     * @returns {Object|null} 折扣计算结果对象
     */
    var calcAllDiscountAmount = function(priceList) {
        // 如果不是数组，直接计算单个商品
        if (!Array.isArray(priceList)) {
            return calculatePriceAndDiscount(priceList);
        }
        
        // 如果是空数组，返回 null
        if (priceList.length === 0) {
            return null;
        }
        
        // 查找主商品对象（isMain 为 true 的项）
        var mainObject = priceList.find(function(item) {
            return item.isMain === true;
        });
        
        // 如果没有找到主商品，返回 null
        if (!mainObject) {
            return null;
        }
        
        // 累加所有商品的价格和对比价
        var totalPrice = priceList.reduce(function(acc, item) {
            return acc + (item.price || 0);
        }, 0);
        
        var totalCompareAtPrice = priceList.reduce(function(acc, item) {
            // 容错处理：如果 compareAtPrice 无效（NaN、undefined、null、0），则使用 price
            var compareAt = item.compareAtPrice || 0;
            var price = item.price || 0;
            return acc + Math.max(compareAt, price);
        }, 0);
        
        // 创建新对象，避免修改原对象
        var calculationParams = {
            productType: mainObject.productType,
            productTags: mainObject.productTags,
            price: totalPrice,
            compareAtPrice: totalCompareAtPrice,
            variantId: mainObject.variantId,
            carePrice: mainObject.carePrice
        };
        
        // 使用累加后的总价格计算折扣（showPromotionInfo 在 calculatePriceAndDiscount 内部读取）
        return calculatePriceAndDiscount(calculationParams);
    };

     /** sentry 错误上报
     * @param {string} error - 错误信息
     * @param {object} options - 选项
     * @param {string} options.tag - 标签
     */
    function sentryErrorReport(error, options = {}) {
        if (window.Sentry) {
            // withScope 方法有点问题，不会上报事件（暂时直接上报）
            window.Sentry.captureException(error);
        }
    }

    return {
        Toast,
        includeLinkStyle,
        isMobileNumber,
        isMobile,
        copyToClipboard,
        getDateStr,
        dateFormat,
        getSignatureHeader,
        getCustomerId,
        getStore,
        getXccApiDomain,
        countDown,
        platform,
        getQueryParams,
        tap,
        loadScript,
        observerEleReady,
        firstWordToUpperCase,
        exceptionNotification,
        feishuNotification,
        feishuSendInteractiveMessage,
        setCookie,
        getCookie,
        deleteCookie,
        checkEmail,
        isElementInViewport,
        getHeaderFixedHeight,
        updateHeaderShadow,
        updateHeaderFixedState,
        isProductPage,
        getSectionByName,
        scrollIntoView,
        getEmarsysCustomerId,
        t,
        lazyLoad,
        getCurrentVariant,
        throttle,
        fetchPtABTest,
        encode,
        fetchJSON,
        getDateTimeStr,
        calculatePriceAndDiscount,
        openBotModal,
        isMaterialProduct,
        getOffLabelText,
        calcAllDiscountAmount,
        sentryErrorReport
    }
})();

/**
*   在init的同时传入相关参数
**/
; (function (win) {
    if (!win.jQuery) {
        $ = {};
        $.fn = {};
    } else if (!win.$) {
        win.$ = jQuery;
    }

    /**
     * 工具集
     * */
    $.tools = {
        format: function (str, data) {
            var matchs = str.match(/{[^}]+?}/g);

            if (matchs === null) {
                return '';
            }

            var maLen = matchs.length;
            data = data instanceof Array ? data : [data];

            var html = '';
            for (var n = 0, len = data.length; n < len; n++) {
                var obj = data[n];

                var temp = str;
                for (var i = 0; i < maLen; i++) {
                    var match = matchs[i];
                    var name = match.replace(/{|}/g, "");
                    temp = temp.replace(match, obj[name] || '');
                }

                html += temp;
            }

            return html;
        }
    }

    /*
    * 分页相关
    */
    $.Pager = function () {
        this.el = null

        this.inited = 0  //是否已经初始化过

        this.curPage = 1
        this.totalPage = 0

        this.total = 0
        this.pageSize = 10

        this.showJump = false;

        this.splitStr = '<li class="disabled"><span class="splitStr"></span></li>'

        this.template =
            '<div class="pager-list">' +
            '    <div class="pager-prev{prevAble}"><</div>' +
            '    <ul>{pageList}</ul>' +
            '    <div class="pager-next{nextAble}">></div>' +
            '</div>'
    }

    ///初始化
    $.Pager.init = function (opt) {
        var page = new $.Pager();

        for (var name in opt) {
            if (opt.hasOwnProperty(name)) {
                page[name] = opt[name];
            }
        }

        var el = opt && opt.el || '[pager]';
        el = typeof el === 'string' ? document.querySelector(el) : el;

        if (el.size && el.size() > 0) {
            el = el[0];
        }

        //元素是否存在
        if (!el) {
            console.error('请指定页码元素, 然后再刷新');
            return;
        }

        //是否显示jump
        page.showJump = page.showJump ? 'inline-block' : 'none';
        page.el = el;
        page.totalPage = Math.ceil(page.total / page.pageSize);
        page.updatePage();

        if (!page.inited) {
            page.inited = 1;
            page.event();
        }
    }

    ///更新页码
    $.Pager.prototype.updatePage = function () {
        var pageList = '';
        var start = this.curPage - 2 > 1 ? this.curPage - 2 : 2;
        var end = this.curPage + 2 < this.totalPage ? this.curPage + 2 : this.totalPage - 1;

        if (this.totalPage > 0) {
            //第一部分
            pageList += '<li';
            pageList += this.curPage === 1 ? ' class="cur"' : '';
            pageList += '>1</li>{splitBefore}';

            //中间页码
            for (var i = start; i <= end; i++) {
                pageList += '<li';
                pageList += i === this.curPage ? ' class="cur"' : '';
                pageList += '>' + i + '</li>';
            }
            // console.log(end, "endend")
            //最后部分
            if (this.totalPage != 1) {
                pageList += '{splitAfter}<li';
                pageList += this.curPage === this.totalPage ? ' class="cur"' : '';
                pageList += '>' + this.totalPage + '</li>';
            }
        }

        var splitData = {
            splitBefore: this.curPage > 2 ? this.splitStr : '',
            splitAfter: this.curPage < this.totalPage - 3 ? this.splitStr : ''
        };

        pageList = $.tools.format(pageList, splitData);


        //页码信息
        var pageData = {
            showJump: this.showJump,

            //上一页与下一页按钮控制
            prevAble: this.curPage === 1 ? ' disabled' : '',
            nextAble: this.curPage === this.totalPage || this.totalPage == 0 ? ' disabled' : '',

            curPage: this.curPage,
            totalPage: this.totalPage,
            pageSize: this.pageSize,
            total: this.total,

            pageList: pageList
        };

        var pageHtml = $.tools.format(this.template, pageData);

        if (!this.totalPage) {
            pageHtml = '';
        }

        this.el.innerHTML = pageHtml;
    }


    ///事件处理
    $.Pager.prototype.event = function () {
        var _this = this;

        _this.el.addEventListener("selectstart", function (e) { e.preventDefault(); });
        // if (__Xtool_Utils.isMobile()) {
        //     _this.el.addEventListener("touchstart", onClickLi, false);
        // } else {
        //     _this.el.addEventListener("click", onClickLi, false);
        // }

        _this.el.addEventListener("click", onClickLi, false);

        function onClickLi(e) {
            var target = e.target;
            var tagName = target.tagName;
            var page = target.textContent - 0;
            var className = target.className;

            if (target.classList.contains("disabled") || target.classList.contains("cur")) {
                return false;
            }

            switch (className) {
                case '': tagName === "LI" && _this.goPage(page); break;
                case 'pager-prev': _this.prev(); break;
                case 'pager-next': _this.next(); break;
                case 'jump-btn': _this.jump(); break;
            }
        }
    }

    $.Pager.prototype.prev = function () {
        if (this.curPage > 1) {
            this.curPage--
        } else {
            return;
        }
        this.goPage();
    }

    $.Pager.prototype.next = function () {
        if (this.curPage < this.totalPage) {
            this.curPage++
        } else {
            return;
        }
        this.goPage();
    }

    $.Pager.prototype.jump = function () {
        var inputEl = this.el.getElementsByTagName('input')[0];
        var pageIndex = inputEl.value.trim() - 0;
        if (isNaN(pageIndex)) {
            console.error('请输入数字');
            pageIndex = this.curPage;
        }
        this.goPage(pageIndex);
    }

    $.Pager.prototype.goPage = function (pageIndex) {
        this.curPage = pageIndex || this.curPage;

        this.curPage = this.curPage < 1 ? 1 : this.curPage;
        this.curPage = this.curPage > this.totalPage ? this.totalPage : this.curPage;

        this.updatePage();
        this.onJump && this.onJump(this.curPage);
    }

    return $.Pager;
})(window);


; (function () {
    if (!String.prototype.replaceAll) {
        String.prototype.replaceAll = function (search, replacement) {
            // 将搜索字符串中的特殊字符进行转义
            var searchRegex = search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            // 创建正则表达式，并使用全局匹配模式
            var regex = new RegExp(searchRegex, 'g');
            // 使用替换字符串替换所有匹配项
            return this.replace(regex, replacement);
        };
    }
})(window)

// '<div class="pager-info">'+
//     '<span class="pager-index-tip">共{total}条,每页{pageSize}</span>'+
//     '<span class="pager-index-tip">{curPage}/{totalPage}</span>'+
//     '<div class="pager-jump" style="display:{showJump}">' +
//         '跳转到 <input value="{curPage}" maxlength="6" />' +
//         '<button class="jump-btn">确定</button>'+
//     '</div>' + 
// '</div>'+
